module.exports = __webpack_public_path__ + "static/media/town-planner.498b9697.jpg";